import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  constructor(private meta: Meta) { 
    this.meta.removeTag('name=keywords');
    this.meta.removeTag('name=description');
    this.meta.addTags([ 
      { name: 'description', content: 'Learn more about our company and our commitment to providing top-notch IT services and solutions in Riyadh, Saudi Arabia. Discover our team expertise and dedication to technology excellence.' }, 
      { name: 'keywords', content: 'osit,it,saudi it,software development,website development' } 
  ]);
  }

  ngOnInit() {
  }


}
